import React from 'react'
import { mergeClassnames } from '@mote/helpers'
import { __DEV__ } from '@mote/helpers/constants'
import styled from '@xstyled/styled-components'
import { TableGenericContext } from './tableGeneric.context'

export const TableFooter = React.forwardRef(
  ({ className, as = 'tfoot', ...props }, ref) => {
    return (
      <TableGenericContext.Provider value={{ variant: 'footer' }}>
        <TableFooterRoot
          as={as}
          className={mergeClassnames('mote-table-body', className)}
          ref={ref}
          role={as === 'tfoot' ? null : 'rowgroup'}
          {...props}
        />
      </TableGenericContext.Provider>
    )
  }
)

if (__DEV__) {
  TableFooter.displayName = 'TableFooter'
}

const TableFooterRoot = styled.theadBox`
  display: table-footer-group;
`
